<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings"></ion-back-button>
    </ion-buttons>
    <ion-title>Site Settings</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask>  

  <ng-container *ngIf="!isLoading">
    <ion-row>
      <ion-col class="hidden-sm-down"></ion-col>

      <ion-col size="12" size-sm="12" size-md="8" size-lg="8" size-xl="8">

        <form [formGroup]='siteSettingsForm'>
<!--           <ion-card>
            <ion-card-header>
              Cancellation Policy
            </ion-card-header>
            <ion-card-content>
              <ion-textarea name='' formControlName="cancellationPolicy" clearInput></ion-textarea>
              <ion-item [hidden]="cancellationPolicy.valid || (cancellationPolicy.pristine && !submitted)">
                <p *ngIf="cancellationPolicy.hasError('maxlength')" class='sm-error'>
                  Cancellation Policy cannot exceed 100 characters.
                </p>
              </ion-item>
              <span class='sm-pale'>This cancellation policy will show at the bottom of your <a href='{{siteUrl}}' target='_blank'>client booking pages</a> and on all your emails.</span>
            </ion-card-content>
          </ion-card> -->

          <ion-card>
            <ion-card-header>
              <ion-card-title> Analytics Code</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <ion-textarea name='' formControlName="analyticsCode" clearInput></ion-textarea>
              <span class='sm-pale'>Add your <a href='https://www.google.com/analytics' target='_blank'>Google analytics</a> code to track usage of your client pages.</span>
            </ion-card-content>
          </ion-card>
          <br/>
          <br/>
          <ion-button 
            class="ion-no-margin hidden-sm-down"
            expand="block"
            (click)="onSiteSettingsSave()">
            Save
          </ion-button>
        </form>
      </ion-col>

      <ion-col class="hidden-sm-down"></ion-col>
    </ion-row>

  </ng-container>
</ion-content>
<!--ion-footer  class="ion-no-margin hidden-md-up">
  <ion-toolbar class="ion-no-margin ion-no-padding">

<ion-footer class="hidden-md-up ion-no-margin">
  <ion-toolbar>
      <ion-button 
        [disabled]="isLoading" 
        class="ion-no-margin"
        
        fill="solid"
        color="primary"
        expand="block"
        (click)="onSiteSettingsSave()">
        Save
      </ion-button>
  </ion-toolbar>
</!--ion-footer-->

<ion-footer class="hidden-md-up ion-no-padding">
  <ion-toolbar class="ion-no-margin ion-no-padding">
    <ion-buttons slot="end">
      <ion-button 
        [disabled]="isLoading" 
        
        fill="solid"
        expand="block"
        color="primary"
        (click)="onSiteSettingsSave()">
        Save
      </ion-button>
    </ion-buttons>   
  </ion-toolbar>
</ion-footer>